import { createSlice } from '@reduxjs/toolkit';

export interface ICallback {
    name: string;
    func: Function;
}

export interface SiteState {
    loading: boolean;
    error?: string;
    message?: string;
    acknowledgedCallback?: Function;
}

let initialState: SiteState = {
    loading: false,
    error: undefined,
    message: undefined
}

export const siteSlice = createSlice({
    name: 'Site',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },
        setAcknowledgedCallback: (state, action) => {
            state.acknowledgedCallback = action.payload;
        }
    }
});

export const { setLoading, setError, setMessage, setAcknowledgedCallback } = siteSlice.actions;

export default siteSlice.reducer;
